var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "",
    width: "1387px",
    height: "1277px",
    viewBox: "0 0 1387 1277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business Woman Working") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created by Webpixels.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business-woman-working",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6,335.7 C11.5,247.3 74.5,161.1 153,129.9 C236.8,96.5 282.1,148.2 404.7,162.2 C657,191 812.2,12 882.6,77.2 C936.8,127.4 843.9,232.7 901.3,320.4 C976.9,435.8 1194.9,340.7 1306.1,456.5 C1389.5,543.3 1410.2,705.2 1348.6,766 C1272.7,840.9 1135,700 926.8,752.4 C753.6,796 762.2,915.4 571.3,990.5 C360.3,1073.5 88.6,1030.4 39,915.7 C4.1,835 107.9,785.4 95.1,630 C83.4,485.9 -11.7,455.7 1.6,335.7 Z",
    id: "Path",
    fill: "rgba(248, 249, 250, 0.30)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,943.8 C298.4,943.8 284.8,593.2 283.1,561.5 C281.4,529.7 289.1,506.7 349.4,505.9 C409.8,505 446.3,515.5 446.3,515.5 C446.3,515.5 473.4,512.7 471.8,681.9 C470.2,851.1 456.7,897.9 456.7,897.9 L540.8,899.1 C561.1,899.4 577.4,915.9 577.4,936.2 L577.4,944.2 C577.4,964.7 560.8,981.3 540.3,981.3 L335.7,981.3 C316.8,981.3 301,967.1 298.9,948.4 L298.4,943.8 Z",
    id: "Path",
    fill: "#ffbb44",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FEAC00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "318.1 509.1 337 905.5 542.6 908.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.2,373.2 C494.2,373.2 492.5,331.8 461.3,330.7 C430.1,329.6 431.3,354.5 422.2,360.2 C413.1,365.9 390.5,368.7 388.8,389.1 C387.1,409.5 391.6,420.8 382,428.8 C372.4,436.8 357.1,443.3 359,459.1 C360.9,474.9 376.3,481.5 365.8,497.4 C355.3,513.3 342.8,515.8 343.7,530 C344.6,544.2 357.9,568 357.9,568 L419,568 C419,568 513,554.7 519.8,544.5 C526.6,534.3 542,514.7 544.6,501.4 C547.2,488.1 550.3,467 546.5,447.7 C544.2,436.2 532.3,415.5 531.5,394.2 C530.5,372.9 501,363.6 494.2,373.2 Z",
    id: "Path",
    fill: "#35404e",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337,
    y1: 905.5,
    x2: 409.6,
    y2: 869.1,
    id: "Path",
    stroke: "#FEAC00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.1,583.6 C1102.1,583.6 1078.4,544.1 1075.6,518 C1072.8,491.9 1077.1,499.1 1084.2,508.4 C1091.2,517.6 1104.8,558.6 1102.1,583.6 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.6,548.2 C1107.6,548.2 1122.9,511.9 1142.4,501.5 C1161.9,491.1 1170.9,486.9 1176,490.7 C1181.1,494.5 1158.6,515.1 1146.7,524 C1134.8,532.9 1107.6,548.2 1107.6,548.2 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.9,839.6 C722.9,839.6 801.2,855.1 803.5,876.7 C805.8,898.3 725.8,1178.9 725.8,1178.9 C725.8,1178.9 748.2,1216.9 763.8,1225.1 C763.8,1225.1 779.1,1235.3 777.4,1241.5 C775.7,1247.7 756.4,1246.9 741.1,1241.5 C725.8,1236.1 692.6,1206.6 693.8,1199.5 C694.9,1192.4 699.2,1173.1 699.8,1165.5 C700.4,1157.8 707.2,966.4 733.6,932 L672.9,921.6 C672.8,921.6 672.8,854.8 722.9,839.6 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.7,1173.3 C703.7,1173.3 692.6,1183.2 692.4,1199.1 C692.2,1215 692.4,1242 692.4,1242 L698,1242 L700.1,1215.5 C700.1,1215.5 710.3,1218.5 713.1,1226.8 C715.9,1235.1 725.2,1246.8 747.1,1251 C769,1255.2 781.9,1255.6 783.4,1248.7 C784.9,1241.8 780.3,1229.4 764.2,1225.2 C764.2,1225.2 736,1226.3 720.9,1208.7 C705.8,1191.1 703.7,1173.3 703.7,1173.3 Z",
    id: "Path",
    fill: "#37B37F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.2,874 C692.2,874 775.5,886.3 777.7,907.8 C780,929.3 700,1202 700,1202 C700,1202 722.4,1240 738,1248.2 C738,1248.2 753.3,1258.4 751.6,1264.6 C749.9,1270.8 730.6,1270 715.3,1264.6 C700,1259.2 666.8,1229.7 668,1222.6 C669.2,1215.5 673.4,1196.2 674,1188.6 C674.6,1181 681.4,989.5 707.8,955.1 L647.1,944.7 C647.1,944.8 642.1,889.2 692.2,874 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.5,749.9 C742.5,749.9 798.7,754.6 812,787.8 L736.5,787.8 C736.5,787.8 731,771.3 733.3,762.4 C735.6,753.5 742.5,749.9 742.5,749.9 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.3,524.8 C501.3,524.8 559.8,594.3 581.7,640.8 C603.6,687.3 626.3,726.4 626.3,726.4 C626.3,726.4 696.6,733.8 744.2,746.2 C744.2,746.2 731.3,770.9 737,789.9 L573.8,772.9 L501.3,552.3 L501.3,528.8 L501.3,524.8 Z",
    id: "Path",
    fill: "#5368f1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.9,515.5 C463.9,515.5 437.9,540.6 431.1,548.2 C424.3,555.8 403.9,588.3 397.5,606.4 C391.1,624.5 359.7,753.8 362,768.2 C364.3,782.6 370.3,787.9 370.3,787.9 L581.8,787.9 C581.8,787.9 570.3,715.1 562.9,693 C555.5,670.9 531.2,585.3 531.2,585.3 C531.2,585.3 514.5,532.1 497.2,521.4 L463.9,515.5 Z",
    id: "Path",
    fill: "#5368f1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.7,
    y1: 616.4,
    x2: 427.9,
    y2: 728.7,
    id: "Path",
    stroke: "#35404e",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 535,
    y1: 598.7,
    x2: 576.2,
    y2: 755.2,
    id: "Path",
    stroke: "#35404e",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.6,754 C554.6,754 581.5,752.7 603.2,762.2 C625,771.8 634.4,780.1 634.4,787.8 L555.6,787.8 C555.7,787.8 546.5,775.2 554.6,754 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.6,
    y1: 754,
    x2: 411.3,
    y2: 726.1,
    id: "Path",
    stroke: "#35404e",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.9,823.7 C414.9,823.7 402.4,841.1 402.8,865.3 C403.2,889.5 409.6,898.9 467.8,909.1 C526,919.3 644.7,949.2 644.7,949.2 C644.7,949.2 695,857.4 727.1,836.6 L414.9,823.7 Z",
    id: "Path",
    fill: "#37B37F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(124.000000, 836.000000)",
    stroke: "#283444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 0.9,
    x2: 0.1,
    y2: 433.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 996.7,
    y1: 0.9,
    x2: 1108.1,
    y2: 433.5,
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1022.2,516.1 C1023.7,517.6 1054.3,598.5 1063.4,635.5",
    id: "Path",
    stroke: "#52CB96",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1069.1,
    y1: 565.7,
    x2: 1084.1,
    y2: 635.5,
    id: "Path",
    stroke: "#52CB96",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.6,487.4 C1119.6,487.4 1107.1,548.1 1103.7,571.3 C1100.3,594.5 1096.9,635.5 1096.9,635.5",
    id: "Path",
    stroke: "#52CB96",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.7,635.5 C1120.7,635.5 1136.3,592 1157.8,565.7",
    id: "Path",
    stroke: "#52CB96",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5368f1",
    fillRule: "nonzero",
    cx: 1066.4,
    cy: 548.2,
    r: 19.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5368f1",
    fillRule: "nonzero",
    cx: 1169.4,
    cy: 552.3,
    r: 19.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.3,508.1 C1017.3,508.1 993.2,501.4 993.2,486.2 C993.2,471 1006.4,483.1 1006.4,483.1 C1006.4,483.1 1018.4,495.3 1021.8,504.5 C1021.8,504.5 1023.7,475.4 1034.4,470.9 C1045.1,466.4 1049.4,476.8 1049.1,479.5 C1048.8,482.2 1048.1,488.2 1042.1,494.1 C1036.1,500 1026.1,505.6 1026.1,505.6 C1026.1,505.6 1044.1,503.6 1051.6,509.2 C1059.2,514.8 1060.3,521.1 1050.1,520.4 C1039.9,519.7 1022.1,515.2 1022.1,515.2 C1022.1,515.2 1013.9,525.6 1003.9,529.1 C993.9,532.6 989.6,524.9 992.5,521 C995.4,517 997.6,508.8 1017.3,508.1 Z",
    id: "Path",
    fill: "#ffbb44",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123,489.9 C1120.9,491.1 1118.4,490.9 1116.5,489.4 C1108.5,483.2 1088.4,463.9 1096.9,432.9 C1096.9,432.9 1099.2,425 1103.8,425.1 C1108.5,425.2 1112.2,448.9 1112.2,448.9 C1112.2,448.9 1115.3,428.8 1120.7,425.1 C1126.1,421.4 1127.6,424 1129.2,428.5 C1130.8,433 1130.1,452.6 1130.1,452.6 C1130.1,452.6 1137.9,429.2 1142.6,425.7 C1147.3,422.2 1150.3,448.1 1148.1,455.7 C1146.1,463 1140.4,480.2 1123,489.9 Z",
    id: "Path",
    fill: "#5368f1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.8,590.7 C1049.8,590.7 1025,585.2 1009,571 C993,556.8 994.1,553.4 996.5,551.2 C999,548.9 1036.8,567.8 1049.8,590.7 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.9,608.9 C1131.9,608.9 1122.2,575.8 1127.5,560.3 C1132.8,544.8 1138.1,590 1134.7,603.2 L1131.9,608.9 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.6,591.8 C1140.6,591.8 1156.4,577.1 1174.9,577.9 C1193.4,578.7 1177,592.1 1169.4,593.2 C1161.7,594.3 1137.5,597.7 1137.5,597.7 L1140.6,591.8 Z",
    id: "Path",
    fill: "#52CB96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero",
    points: "944 679.5 699.5 679.5 712.3 492.8 956.8 492.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.9,578 C858.6,567.5 849.3,560.1 838.6,560.1 C824.4,560.1 813.6,573 816.2,587 L849.9,770.9 L812.5,771.4 L809.8,787.8 L906.5,787.8 L860.9,578 Z M845,616.9 C839.7,617.9 834.3,612.3 832.9,604.4 C831.5,596.5 834.6,589.4 839.9,588.5 C845.2,587.5 850.6,593.1 852,601 C853.4,608.9 850.3,615.9 845,616.9 Z",
    id: "Shape",
    fill: "#283444",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CED5E5",
    fillRule: "nonzero",
    x: 121.5,
    y: 787.8,
    width: 1113.2,
    height: 49.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero",
    points: "441 1129.8 441 981.2 421.1 981.2 421.1 1129.8 334.4 1172.3 334.4 1184.2 431 1153.6 527.7 1184.2 527.7 1172.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED5E5",
    fillRule: "nonzero",
    points: "441 1126.6 491.4 1131.9 491.4 1145.3 441 1143.1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#283444",
    fillRule: "nonzero",
    cx: 348.2,
    cy: 1199.6,
    r: 13.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#283444",
    fillRule: "nonzero",
    cx: 513.9,
    cy: 1199.6,
    r: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.4,1193.7 C673.4,1193.7 662.3,1203.6 662.1,1219.5 C661.9,1235.4 662.1,1262.4 662.1,1262.4 L667.7,1262.4 L669.8,1235.9 C669.8,1235.9 680,1238.9 682.8,1247.2 C685.6,1255.5 694.9,1267.2 716.8,1271.4 C738.7,1275.6 751.6,1276 753.1,1269.1 C754.6,1262.2 750,1249.8 733.9,1245.6 C733.9,1245.6 705.7,1246.7 690.6,1229.1 C675.5,1211.5 673.4,1193.7 673.4,1193.7 Z",
    id: "Path",
    fill: "#37B37F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.5,635.5 L1086.9,635.5 L1022.3,635.5 L1043.4,672.5 C1051.3,686.4 1050.7,703.6 1041.8,716.9 L1041.8,716.9 C1032.6,730.8 1031.6,748.6 1039.3,763.3 L1039.3,763.3 C1047.2,778.3 1062.7,787.7 1079.7,787.7 L1086.9,787.7 L1094.1,787.7 C1111.1,787.7 1126.6,778.3 1134.5,763.3 L1134.5,763.3 C1142.2,748.5 1141.3,730.7 1132,716.9 L1132,716.9 C1123.1,703.6 1122.5,686.4 1130.4,672.5 L1151.5,635.5 Z",
    id: "Path",
    fill: "#f05d27",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441,
    y1: 1129.8,
    x2: 527.7,
    y2: 1172.3,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.2,874 C692.2,874 775.5,886.3 777.7,907.8 C779.6,925.8 724.2,1118.7 705.9,1182",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.9,515.5 C463.9,515.5 472.6,501.1 469.2,490.6 C465.8,480 460.1,477.5 463.3,464.8 C466.5,452.1 464.9,445.1 462.3,440.3 C459.8,435.5 453.4,421.6 458.5,406.1 C463.6,390.6 491.3,388.1 506.4,394.8 C506.4,394.8 520,415 520.4,444.9 C520.8,474.8 509.4,490.3 505.1,492.9 C500.8,495.5 486.2,489.9 486.2,489.9 C486.2,489.9 492.6,515.2 497,521.5 C497.1,521.3 480.1,525.7 463.9,515.5 Z",
    id: "Path",
    fill: "#FFDFD7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 812.5,
    y1: 771.4,
    x2: 873.8,
    y2: 770.9,
    id: "Path",
    stroke: "#CED5E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    fill: "#CED5E5",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 672.8,
    y: 0.1,
    width: 259.1,
    height: 323.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "rgba(248, 249, 250, 0.30)",
    fillRule: "nonzero",
    x: 700.6,
    y: 27.9,
    width: 203.5,
    height: 267.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(700.000000, 181.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6,0.3 C21,0.3 21,4.3 41.3,4.3 C61.7,4.3 61.7,0.3 82,0.3 C102.4,0.3 102.4,4.3 122.7,4.3 C143.1,4.3 143.1,0.3 163.4,0.3 C183.8,0.3 183.8,4.3 204.1,4.3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,14.8 C21,14.8 21,18.8 41.3,18.8 C61.7,18.8 61.7,14.8 82,14.8 C102.4,14.8 102.4,18.8 122.7,18.8 C143.1,18.8 143.1,14.8 163.4,14.8 C183.8,14.8 183.8,18.8 204.1,18.8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,29.2 C21,29.2 21,33.2 41.3,33.2 C61.7,33.2 61.7,29.2 82,29.2 C102.4,29.2 102.4,33.2 122.7,33.2 C143.1,33.2 143.1,29.2 163.4,29.2 C183.8,29.2 183.8,33.2 204.1,33.2",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,43.7 C21,43.7 21,47.7 41.3,47.7 C61.7,47.7 61.7,43.7 82,43.7 C102.4,43.7 102.4,47.7 122.7,47.7 C143.1,47.7 143.1,43.7 163.4,43.7 C183.8,43.7 183.8,47.7 204.1,47.7",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,58.2 C21,58.2 21,62.2 41.3,62.2 C61.7,62.2 61.7,58.2 82,58.2 C102.4,58.2 102.4,62.2 122.7,62.2 C143.1,62.2 143.1,58.2 163.4,58.2 C183.8,58.2 183.8,62.2 204.1,62.2",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,72.6 C21,72.6 21,76.6 41.3,76.6 C61.7,76.6 61.7,72.6 82,72.6 C102.4,72.6 102.4,76.6 122.7,76.6 C143.1,76.6 143.1,72.6 163.4,72.6 C183.8,72.6 183.8,76.6 204.1,76.6",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,87.1 C21,87.1 21,91.1 41.3,91.1 C61.7,91.1 61.7,87.1 82,87.1 C102.4,87.1 102.4,91.1 122.7,91.1 C143.1,91.1 143.1,87.1 163.4,87.1 C183.8,87.1 183.8,91.1 204.1,91.1",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,101.5 C21,101.5 21,105.5 41.3,105.5 C61.7,105.5 61.7,101.5 82,101.5 C102.4,101.5 102.4,105.5 122.7,105.5 C143.1,105.5 143.1,101.5 163.4,101.5 C183.8,101.5 183.8,105.5 204.1,105.5",
    id: "Path"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 832,
    cy: 79.8,
    r: 17
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.9fd0f15b2b6dff76c06e58e0c5d67d7d.svg";
export { ForwardRef as ReactComponent };